module.exports = __webpack_public_path__ + "img/E1 Dot Box Black.be943da3.png";